define('SuiteDynamics.ShopByCategory.Entrypoint',
	[
		'SuiteDynamics.ShopByCategory.HorizontalCategories'
	],
	function (
		HorizontalCategories
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			HorizontalCategories.mountToApp(container);
		}
	};
});
